/**
 * Operations / warehouse — routes inside the platform shell.
 *
 * One screen with a tab per job: stock by batch, movements, transfers,
 * adjustment requests, physical verification and locations.
 */
import { lazy } from 'react';
import type { ReactElement } from 'react';
import { Route } from 'react-router-dom';
import { RequirePermission } from '@/components/shared/RequirePermission';

const WarehousePage = lazy(() => import('./WarehousePage'));

const page = () => (
  <RequirePermission module="erp.warehouse.stock" what="warehouse stock">
    <WarehousePage />
  </RequirePermission>
);

export function warehouseRoutes(): ReactElement[] {
  return [
    <Route key="erp-warehouse" path="erp/warehouse" element={page()} />,
    <Route key="erp-warehouse-tab" path="erp/warehouse/:tab" element={page()} />,
  ];
}
